module.exports = __webpack_public_path__ + "static/media/upload_customers.13132c2a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_menu_icons/upload_customers.svg
// module id = 2726
// module chunks = 0